import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { SandBoxedIframe } from './FileRenderer';

export function callUtilFunctionInSandBoxedIframe(
    functionName: string,
    args: any[],
    timeoutMs: number = 30000,
): Promise<any> {
    return new Promise((resolve, reject) => {
        const container = document.createElement('div');
        container.style.display = 'none';
        document.body.appendChild(container);

        const root = ReactDOM.createRoot(container);

        const timeoutId = setTimeout(() => {
            root.unmount();
            container.remove();
            reject(new Error(`Utility function '${functionName}' timed out after ${timeoutMs}ms`));
        }, timeoutMs);

        root.render(
            <StrictMode>
                <SandBoxedIframe
                    onLoadCallback={async (utils) => {
                        try {
                            const result = await utils.callUtilFunction(functionName, args);
                            clearTimeout(timeoutId);
                            resolve(result);
                        } catch (error) {
                            clearTimeout(timeoutId);
                            reject(error);
                        } finally {
                            setTimeout(() => {
                                root.unmount();
                                container.remove();
                            }, 100);
                        }
                    }}
                />
            </StrictMode>,
        );
    });
}
